import React from 'react'
import { inject, observer } from 'mobx-react'

import Categories from './Categories'

const Explore = ({ dropdownStore, translationStore, exploreStore, location }) => {
  const ifItsAHandheldDevice = (doThis) => {
    if(window.outerWidth < 0) return doThis
  }

  const ifItsPC = (doThis) => {
    if(window.outerWidth >= 1024) return doThis
  }

  const marginTop = ((dropdownStore.showSearchDropdown || dropdownStore.showProfileDropdown)
                      && 'mt-dropdown')

  const showCategoriesClass = exploreStore.isShowingCategories ? 'active' : ''

  return (
    <div className='nav-explore'><Categories location={location} /></div>
  )
}

export default inject('dropdownStore', 'translationStore', 'exploreStore')(observer(Explore))



// WEBPACK FOOTER //
// ./src/components/Explore/index.js